<template>
    <div class="view view--add-admin-user">
        <edit-user v-bind:id="id" />
    </div>
</template>

<script>
    import editUser from '../../components/EditUser.vue';

    export default {
        components: {
            editUser
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.user) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/users/Edit.vue